import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { APP_ROUTES } from '@core/constants';
import { ErrorPageGuard } from '@core/services/error-page';
import { ErrorPageComponent } from '@shared/components';
import { SelectivePreloadStrategy } from '@core/services/selective-preload-strategy';

const routes: Routes = [
  {
    path: APP_ROUTES.AUTH_CALLBACK,
    loadChildren: () => import('@modules/sign-in/sign-in.module').then(m => m.SignInModule),
    data: { preload: true }
  },
  {
    path: APP_ROUTES.BASE,
    loadChildren: () => import('@modules/sign-in/sign-in.module').then(m => m.SignInModule),
    data: { preload: true }
  },
  {
    path: APP_ROUTES.SIGNUP,
    loadChildren: () => import('@modules/sign-up/sign-up.module').then(m => m.SignUpModule)
  },
  {
    path: APP_ROUTES.PASSWORD,
    loadChildren: () => import('@modules/password/password.module').then(m => m.PasswordModule)
  },
  {
    path: APP_ROUTES.VERIFICATION,
    loadChildren: () =>
      import('@modules/verification/verification.module').then(m => m.VerificationModule)
  },
  {
    path: APP_ROUTES.MFA_CHALLENGE,
    loadChildren: () =>
      import('@modules/mfa-challenge/mfa-challenge.module').then(m => m.MfaChallengeModule)
  },
  {
    path: APP_ROUTES.SET_PASSWORD,
    loadChildren: () =>
      import('@modules/set-password-challenge/set-password-challenge.module').then(
        m => m.SetPasswordChallengeModule
      )
  },
  {
    path: APP_ROUTES.REQUIRED_ACTIONS,
    loadChildren: () =>
      import('@modules/required-actions/required-actions.module').then(m => m.RequiredActionsModule)
  },
  {
    path: APP_ROUTES.PROFILE,
    loadChildren: () => import('@modules/profile/profile.module').then(m => m.ProfileModule)
  },
  {
    path: 'my-profile',
    redirectTo: APP_ROUTES.PROFILE,
    pathMatch: 'prefix'
  },
  {
    path: APP_ROUTES.DASHBOARD,
    loadChildren: () => import('@modules/dashboard/dashboard.module').then(m => m.DashboardModule),
    data: { preload: true }
  },
  {
    path: APP_ROUTES.ERROR,
    canActivate: [ErrorPageGuard],
    component: ErrorPageComponent
  },
  // Fallback when no prior route is matched
  { path: '**', redirectTo: APP_ROUTES.DASHBOARD }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: SelectivePreloadStrategy })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
